import { Button } from "primereact/button";
import React, { ReactNode } from "react";
import { FiPlus } from "react-icons/fi";
import "./CardLayout.scss";

export default function CardLayout({
  children,
  title,
  addButtonClicked,
}: {
  children: ReactNode;
  title: string;
  addButtonClicked: any;
}) {
  return (
    <section className="card-layout">
      <div className="header">
        <h2>Your {title}</h2>
        <Button className="primary" raised onClick={() => addButtonClicked()}>
          <FiPlus /> Add {title.slice(0, -1)}
        </Button>
      </div>
      <div className="cards">{children}</div>
    </section>
  );
}
